module.exports = __webpack_public_path__ + "img/logo.81f0af54.png";